import { useState } from "react";
import { FaChevronLeft, FaCheckCircle, FaInbox } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  FormItem,
  Input,
  useForm,
} from "@/frontend/components/common";
import { authService } from "@/frontend/services";

export function ForgotPasswordPage() {
  const [isSent, setIsSent] = useState(false);
  const [form] = useForm();
  const [email, setEmail] = useState("");

  const handleSubmit = async (values: { email: string }) => {
    try {
      await authService.forgotPassword(values);
      setEmail(values.email);
      setIsSent(true);
    } catch (error) {
      form.setFields([
        {
          name: "email",
          errors: ["No pudimos procesar tu solicitud."],
        },
      ]);
    }
  };

  return (
    <div className="h-screen w-full flex items-center justify-center bg-slate-50 p-6 font-sans relative overflow-hidden">
      {/* Visual Background */}
      <div className="absolute inset-0 z-0 opacity-10">
        <img
          src="/stadium-bg.png"
          alt="Stadium"
          className="absolute inset-0 w-full h-full object-cover grayscale"
        />
      </div>

      <div className="relative z-10 w-full max-w-lg flex flex-col items-center">
        {!isSent ? (
          <div className="w-full bg-white rounded-3xl p-10 md:p-14 border border-slate-100 shadow-2xl shadow-slate-200">
            <div className="mb-10 text-center">
              <div className="w-16 h-16 bg-emerald-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <FaInbox className="text-emerald-600 text-2xl" />
              </div>
              <h1 className="text-3xl font-bold text-slate-900 mb-3 tracking-tight">
                Recuperar acceso
              </h1>
              <p className="text-slate-500 font-medium">
                Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
              </p>
            </div>

            <Form
              form={form}
              onFinish={handleSubmit}
              layout="vertical"
              className="space-y-6"
            >
              <FormItem
                name="email"
                label={<span className="text-slate-700 text-sm font-semibold ml-1">Correo Electrónico</span>}
                rules={[
                  { required: true, message: "Campo obligatorio" },
                  { type: "email", message: "Formato no válido" },
                ]}
              >
                <Input
                  placeholder="ejemplo@correo.com"
                  size="large"
                  className="bg-slate-50 border-slate-200 text-slate-900 h-14 rounded-xl focus:border-emerald-500 focus:bg-white transition-all placeholder:text-slate-400"
                />
              </FormItem>

              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="h-14 bg-emerald-600 hover:bg-emerald-500 border-none rounded-xl text-lg font-bold shadow-lg shadow-emerald-100 text-white transition-all transform active:scale-[0.98]"
              >
                Enviar instrucciones
              </Button>
            </Form>

            <Link
              to="/login"
              className="flex items-center justify-center gap-2 text-slate-400 hover:text-emerald-600 transition-colors mt-8 font-bold text-sm"
            >
              <FaChevronLeft className="text-[10px]" />
              Volver al inicio
            </Link>
          </div>
        ) : (
          <div className="w-full bg-white rounded-3xl p-10 md:p-14 border border-slate-100 shadow-2xl shadow-slate-200 text-center">
            <div className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8 border border-emerald-100">
              <FaCheckCircle className="text-emerald-500 w-10 h-10" />
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4 tracking-tight">
              ¡Correo enviado!
            </h2>
            <p className="text-slate-500 font-medium mb-8">
              Hemos enviado un enlace a <br />
              <span className="text-slate-900 font-bold">{email}</span>
            </p>

            <p className="text-slate-500 text-sm mb-8">
              Revisa tu bandeja de entrada. Desde el celular se abrirá la app si la tienes instalada;
              desde el navegador podrás cambiar la contraseña directamente.
            </p>

            <Link to="/login">
              <Button
                type="primary"
                size="large"
                block
                className="h-14 bg-slate-900 hover:bg-slate-800 text-white border-none rounded-xl font-bold transition-all"
              >
                Cerrar e ir al Login
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
